import React, { useState } from "react";
import { useProfile } from "../../hook/useProfile";
import DefaultProfileImg from "../../assets/images/profile/userProfile.png";
import VandeMataram from "../../assets/images/badge/VandeMataram.png";

import "./FrameModel.css";
const FrameModal = ({ isOpen, onClose, onApply, profileImage, badgeImage }) => {
  const [selected, setSelected] = useState("normal");

  if (!isOpen) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          {/* Header */}
          <div className="modal-header">
            <h5 className="modal-title-title">Select Profile Frame</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          {/* Body */}
          <div className="modal-body">
            <div className="d-flex gap-3 justify-content-center">
              {/* Normal Image */}
              <div
                className={` card p-2 text-center ${
                  selected === "normal" ? "border-primary" : ""
                }`}
                onClick={() => setSelected("normal")}
              >
                <img
                  src={profileImage}
                  onError={(e) => {
                    e.target.src =
                      "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                  }}
                  alt="Normal"
                  className="model_profile_img"
                />
                <p className="card_name_model mt-2 mb-0">Original</p>
              </div>

              {/* Badge Image */}
              <div
                className={` card p-2 text-center position-relative ${
                  selected === "badge" ? "border-primary" : ""
                }`}
                onClick={() => setSelected("badge")}
              >
                <div className="position-relative">
                  <img
                    src={profileImage}
                    onError={(e) => {
                      e.target.src =
                        "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                    }}
                    alt="Profile"
                    className="model_profile_img "
                  />
                  <img
                    src={VandeMataram}
                    alt="Badge"
                    className="profile_badge_img"
                  />
                </div>
                <p className="card_name_model mt-2 mb-0">Vandemataram</p>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Cancel
            </button>

            <button
              type="button"
              className="submit_badge_profile"
              onClick={() => onApply(selected)}
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FrameModal;
